<div class="ui basic segment" [class.loading]="isLoading">
    <div class="flex align-items-center">
        <app-header
            *ngIf="employee"
            title="Adjustment History"
            [subtitle]="'For ' + employee?.fullName"
            [back]="true"
        ></app-header>
        <div *ngIf="employee && displayMakeAdjustmentButton" class="flex justify-end">
            <ui-button
                [type]="'primary'"
                [routerLink]="['/payroll/vacation-ytd-adjuster/make-adjustment', employee.id]"
            >
                Make Adjustment
            </ui-button>
        </div>
    </div>
    <ui-card>
        <app-segment-header class="margin-top-2" title="Adjustment History"></app-segment-header>
        <ui-banner variant="info" class="margin-y-3">
            Please note that any dollar adjustments made will be pending and be picked up in the next payroll. If you
            want to adjust time, please go to Time Off.
        </ui-banner>

        <app-table
            *ngIf="displayVacationYtdAdjustmentHistoryTable"
            [useStickyHeader]="false"
            [table]="vacationYtdAdjusmentsHistoryTable"
            [showSearch]="false"
            [useStickyHeader]="false"
            [showOffset]="false"
            [showActionsPadding]="false"
            [embedded]="true"
            class="table margin-top-3"
        >
            <app-empty-state
                [label]="
                    !vacationYtdAdjusmentsHistoryTable.hasFiltersApplied()
                        ? 'There are no adjustments transactions to display'
                        : ''
                "
                src="/assets/illustrations/piggy-bank.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
